"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getFileNameFromUrl(url) {
    var hashIndex = url.indexOf('#');
    url = hashIndex !== -1 ? url.substring(0, hashIndex) : url;
    return (url.split('/').pop() || '').replace(/[\?].*$/g, '');
}
exports.getFileNameFromUrl = getFileNameFromUrl;
function getParametersFromUrl(url) {
    var queryString = url.split('?')[1];
    var obj = {};
    if (!queryString) {
        return obj;
    }
    queryString = queryString.split('#')[0];
    var arr = queryString.split('&');
    for (var i = 0; i < arr.length; i++) {
        var a = arr[i].split('=');
        obj[a[0]] = a[1] || '';
    }
    return obj;
}
exports.getParametersFromUrl = getParametersFromUrl;
//# sourceMappingURL=url.js.map